import { EventBus, EventBusEvent } from "./EventBus";

let popupManager = null;
const instanceEnforcer = Symbol('instanceEnforcer');
const eventBus = new EventBus();

const PopupManagerEvent = Object.freeze({
    OPEN: 'open',
    CLOSE: 'close'
});

export class PopupManager {
    _isOpenResolver = () => false;

    /**
     * @return {PopupManager}
     */
    static get instance() {
        if (popupManager == null) {
            popupManager = new PopupManager(instanceEnforcer);
        }
        return popupManager;
    }

    get isOpen() {
        return this._isOpenResolver();
    }

    setIsOpenResolver(resolver) {
        this._isOpenResolver = resolver;
    }

    /**
     * Constructor
     *
     * @param {symbol} enforcer  singleton enforcer
     */
    constructor(enforcer) {
        if (enforcer !== instanceEnforcer) {
            throw new Error(`Instantiation failed: use PopupManager.instance`);
        }
    }

    /**
     * @param {any} [data]
     * @return {Promise<any>}
     */
    open(data) {
        return new Promise((resolve) => {
            eventBus.trigger(new EventBusEvent(PopupManagerEvent.OPEN), {
                ...data,
                resolve
            });
        });
    }

    /**
     * @return {Promise<any>}
     */
    close() {
        return new Promise((resolve) => {
            eventBus.trigger(new EventBusEvent(PopupManagerEvent.CLOSE), {
                resolve
            });
        });
    }

    /**
     * Registers open() observer (used by the env)
     *
     * @param {({ resolve: (function(...args?: IArguments): void) })} handler  open handler invoked by @see open()
     * @return {function(): void}   dispose function to unregister observer
     */
    onOpen(handler) {
        const event = new EventBusEvent(PopupManagerEvent.OPEN);
        return eventBus.listen(event, (_, data) => handler(data));
    }

    /**
     * Registers close() observer (used by the env)
     *
     * @param {({ resolve: (function(...args?: IArguments): void) })}} handler     close handler invoked by @see close()
     * @return {function(): void}   dispose function to unregister observer
     */
    onClose(handler) {
        const event = new EventBusEvent(PopupManagerEvent.CLOSE);
        return eventBus.listen(event, (_, data) => handler(data));
    }
}
